module.exports = __webpack_public_path__ + "static/media/vishnu.72709b38.jpeg";